var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, DialogContent, Box } from "@mui/material";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { styled } from "@mui/system";
import { IconButton } from "@sequentech/ui-essentials";
var DialogStyle = styled(Dialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    & .MuiPaper-root {\n        width: 650px;\n        max-width: unset;\n        padding-bottom: 12px;\n    }\n    & .MuiDialogContent-root {\n        @media (max-width: ", "px) {\n            padding: 16px 24px 0 24px !important;\n        }\n    }\n"], ["\n    & .MuiPaper-root {\n        width: 650px;\n        max-width: unset;\n        padding-bottom: 12px;\n    }\n    & .MuiDialogContent-root {\n        @media (max-width: ", "px) {\n            padding: 16px 24px 0 24px !important;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.sm;
});
var FormDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, title = _a.title, children = _a.children;
    return (_jsxs(DialogStyle, __assign({ open: open, onClose: onClose, className: "dialog" }, { children: [_jsxs(DialogTitle, __assign({ className: "dialog-title" }, { children: [_jsx(Box, __assign({ component: "span", flexGrow: 2, pt: "3px", fontWeight: "bold", className: "dialog-title-text" }, { children: title })), _jsx(IconButton, { icon: faTimesCircle, variant: "primary", onClick: function () { return onClose(); }, className: "dialog-icon-close" })] })), _jsx(DialogContent, __assign({ className: "dialog-content" }, { children: children }))] })));
};
export default FormDialog;
var templateObject_1;
